'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SEARCH_ID_LOCAL_STORAGE_KEY = 'searchInstanceId';

exports.default = function () {
  var localStorageData = void 0;
  try {
    localStorageData = window.localStorage.getItem(SEARCH_ID_LOCAL_STORAGE_KEY);
  } catch (err) {
    /* noop */
  }
  var data = JSON.parse(localStorageData || 'null');
  if (data && data.createdAt > Date.now() - 30 * 60 * 1e3) {
    return data.id;
  }
};